export const keyTransform = data => {
	const newData = {};

	Object.keys(data).forEach(key => {
		const keyArray = key.split('_');

		const newKey = keyArray.reduce((prev, cur) => {
			if (prev === '') {
				return cur;
			}

			if (cur.length > 0) {
				return `${prev}${cur[0].toUpperCase()}${cur.slice(1)}`;
			}

			return prev;
		}, '');

		newData[newKey] = data[key];
	});

	return newData;
};



// WEBPACK FOOTER //
// ./src/util/helper.js